class DoctorSearch {
  constructor() {
    this.googleSpreedSheet = JSON.parse(
      document.querySelector("#google-spreed-sheet").textContent
    ).url;

    this.getSpreedSheetContent();
  }

  async getSpreedSheetContent() {
    try {
      const request = await fetch(this.googleSpreedSheet);
      const response = await request.text();
      const doctorsData = Papa.parse(response, {
        header: true,
      });
      const formattedDoctorsData = this.formatDoctorObject(doctorsData.data);
      this.dispatchSpreedSheetData(formattedDoctorsData);
    } catch (error) {
      console.error(`DoctorSearch | getSpreedSheetContent | Error: ${error}`);
    }
  }

  dispatchSpreedSheetData(doctorsData) {
    const event = new CustomEvent("doctors-data-parsed", {
      detail: doctorsData,
    });
    document.dispatchEvent(event);
  }

  formatDoctorObject(data) {
    return data.map((doctor) => {
      return {
        name: doctor["Name"],
        webAddress: doctor["Web address"] ? doctor["Web address"] : "",
        specialty: doctor["Specialty"],
        location: doctor["Location"],
        fullLocation: doctor["Full location"],
        contactInfo: doctor["Contact info"],
        endorsement: doctor["Uqora community endorsement"],
        tags: doctor[
          "Tags (csv, no html)\nTelemedicine, Urologist, General Practitioners, OB/GYNs, Physical Therapists, Menopausal Care, IC, Pelvic Floor Health, Urogynecology, Functional Medicine, Internal Medicine"
        ],
        state: doctor["State"],
      };
    });
  }
}

class DoctorSearchFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.specialtyFilters = document.querySelector(
      "doctor-search-specialty-filters"
    );

    this.locationFilters = document.querySelector(
      "doctor-search-location-filter"
    );

    document.addEventListener("filter-specialties", (event) => {
      const specialties = event.detail;
      this.filterDoctorsBySpecialties(specialties);
    });

    document.addEventListener("filter-locations", (event) => {
      const location = event.detail;
      this.filterDoctorsByLocations(location);
    });
  }

  filterDoctorsBySpecialties(specialties) {
    this.dispatchFilterEvent({
      specialties,
      location: this.locationFilters.getLocationValue(),
    });
  }

  filterDoctorsByLocations(location) {
    this.dispatchFilterEvent({
      specialties: this.specialtyFilters.getCheckedValues(),
      location,
    });
  }

  dispatchFilterEvent(values) {
    const event = new CustomEvent("doctor-search-filter", {
      detail: values,
    });
    document.dispatchEvent(event);
  }

  disconnectedCallback() {
    document.removeEventListener("filter-specialties");
    document.removeEventListener("filter-locations");
  }
}

class SpecialtyFilters extends HTMLElement {
  constructor() {
    super();
    this.doctorsData = [];
    this.specialties = [];
  }

  connectedCallback() {
    this.specialtyList = this.querySelector("#specialty--list");
    this.loadingSpinner = this.querySelector("#specialty--loading");
    this.emptyState = this.querySelector("#specialty--empty");

    document.addEventListener("doctors-data-parsed", (event) => {
      this.doctorsData = event.detail;
      this.getSpecialties();
      this.renderSpecialties();
      this.removeLoadingState();
    });

    this.specialtyList.addEventListener(
      "input",
      this.inputEventHandler.bind(this)
    );
  }

  getSpecialties() {
    let tags = this.doctorsData
      .map((doctor) => {
        return doctor.tags.split(",");
      })
      .flat();
    tags = tags.map((tag) => tag.trim());
    const uniqueTags = new Set(tags);
    this.specialties = Array.from(uniqueTags).sort();
  }

  renderSpecialties() {
    this.specialtyList.innerHTML = `
      ${this.specialties
        .map((element, index) => {
          if (element === "") return;
          return `
          <input type="checkbox" id="tag-${index}"  value="${element.trim()}" />
          <label class="specialty-item" for="tag-${index}">${element.trim()}</label>
          `;
        })
        .join("")}
    `;
  }

  inputEventHandler() {
    const checkedValues = this.getCheckedValues();
    this.dispatchFilterEvent(checkedValues);
  }

  dispatchFilterEvent(values) {
    const event = new CustomEvent("filter-specialties", {
      detail: values,
    });
    document.dispatchEvent(event);
  }

  getCheckedValues() {
    return Array.from(this.specialtyList.querySelectorAll("input:checked")).map(
      (input) => input.value
    );
  }

  removeLoadingState() {
    this.loadingSpinner.dataset.showLoading = false;
  }

  disconnectedCallback() {
    document.removeEventListener("doctors-data-parsed");
    this.specialtyList.removeEventListener(
      "input",
      this.inputEventHandler.bind(this)
    );
  }
}

class LocationFilter extends HTMLElement {
  constructor() {
    super();
    this.doctorsData = [];
    this.locationsArray = [];
  }

  connectedCallback() {
    this.locationsDropdown = this.querySelector("#doctor-search--locations");
    this.loadingSpinner = this.querySelector("#location--loading");

    document.addEventListener("doctors-data-parsed", (event) => {
      this.doctorsData = event.detail;
      this.getLocations();
      this.removeLoadingState();
    });

    this.locationsDropdown.addEventListener(
      "change",
      this.locationsDropdownHandler.bind(this)
    );
  }

  getLocations() {
    const locations = new Set(
      this.doctorsData.map((doctor) => doctor["Location"])
    );
    this.locationsArray = Array.from(locations);
  }

  locationsDropdownHandler() {
    const selectedLocation = this.getLocationValue();
    const event = new CustomEvent("filter-locations", {
      detail: selectedLocation,
    });
    document.dispatchEvent(event);
  }

  removeLoadingState() {
    this.loadingSpinner.dataset.showLoading = false;
    this.locationsDropdown.disabled = false;
  }

  getLocationValue() {
    return this.locationsDropdown.value;
  }

  disconnectedCallback() {
    document.removeEventListener("doctors-data-parsed");
    this.locationsDropdown.removeEventListener(
      "change",
      this.locationsDropdownHandler.bind(this)
    );
  }
}

class SearchResults extends HTMLElement {
  constructor() {
    super();
    this.cardsPerPage = 10;

    this.doctorsData = [];
    this.onlineLocations = ["online", "telemedicine", "telemed"];

    this.specialtyFiltersComponent = document.querySelector(
      "doctor-search-specialty-filters"
    );

    this.locationFilterComponent = document.querySelector(
      "doctor-search-location-filter"
    );

    this.domParser = new DOMParser();
  }

  connectedCallback() {
    this.resultsList = this.querySelector("#results--list");
    this.paginationContainer = this.querySelector("#results--pagination");
    this.loadingSpinner = this.querySelector("#results--loading");
    this.emptyState = this.querySelector("#results--empty");

    document.addEventListener("doctors-data-parsed", (event) => {
      this.doctorsData = event.detail;
      this.renderDoctors();
      this.removeLoadingState();
    });

    document.addEventListener("doctor-search-filter", (event) => {
      const activeFilters = event.detail;
      this.filterDoctors(activeFilters);
    });

    this.paginationContainer.addEventListener(
      "click",
      this.paginationHandler.bind(this)
    );
  }

  filterDoctors(activeFilters) {
    const { specialties, location } = activeFilters;

    const filteredBySpecialties = this.filterDoctorsBySpecialties(specialties);
    const filteredByLocation = this.filterDoctorsByLocation(
      location,
      filteredBySpecialties
    );

    this.renderDoctors(filteredByLocation);
    this.scrollSectionIntoView();
  }

  filterDoctorsBySpecialties(specialties) {
    if (specialties.length === 0) return this.doctorsData;

    return this.doctorsData.filter((doctor) => {
      let doctorTags = doctor.tags.split(",").map((tag) => tag.trim());
      return doctorTags.some((tag) => specialties.includes(tag));
    });
  }

  filterDoctorsByLocation(location, filteredDocsArray) {
    if (location === "All") return filteredDocsArray;

    if (location === "Online") {
      return filteredDocsArray.filter((doctor) => {
        let { tags, location } = doctor;
        return this.onlineLocations.some(
          (keyword) =>
            this.stringIncludesCaseInsensitive(keyword, tags) ||
            this.stringIncludesCaseInsensitive(keyword, location)
        );
      });
    }

    return filteredDocsArray.filter((doctor) => {
      const [state, stateCode] = this.formatLocationObject(location);
      return doctor.state === state || doctor.location.includes(stateCode);
    });
  }

  renderDoctors(doctorsData = this.doctorsData) {
    this.resultsList.innerHTML = "";

    this.toggleEmptyResultsMessage(doctorsData.length === 0);
    this.togglePagination(doctorsData.length === 0);
    if (doctorsData.length === 0) return;

    const pages = Math.ceil(doctorsData.length / this.cardsPerPage);
    this.buildPaginationButtons(pages);
    const dataPaginated = this.buildPaginationPages(
      doctorsData,
      this.cardsPerPage
    );

    this.resultsList.innerHTML = `
      ${dataPaginated
        .map((doctorsData, index) => {
          return `
            <div
              class="doctor-results-page"
              data-doctor-results-page="${index + 1}"
              data-doctor-results-active-page="${index === 0 ? true : false}"
            >
              ${doctorsData
                .map((doctor) => {
                  return `
                    <div class="doctor-card">
                      <h3>
                        <a
                          href="${doctor.webAddress}"
                          title="${doctor.name}'s web address"
                          target="_blank"
                          >${doctor.name}</a
                        >
                      </h3>
                      <p>${doctor.specialty}</p>
                      <details>
                        <summary>
                          ${doctor.location} <span>(see address)</span>
                        </summary>
                        <p>${doctor.fullLocation}</p>
                      </details>
                      <p>Phone number: ${doctor.contactInfo}</p>
                      
                     ${this.parseEndorsementString(doctor.endorsement)}
                      
                      <ul class="doctor-tags">
                        ${doctor.tags
                          .split(",")
                          .map((tag) => `<li><span>${tag.trim()}</span></li>`)
                          .join("")}
                      </ul>
                    </div>
                  `;
                })
                .join("")}
            </div>
          `;
        })
        .join("")}
    `;
  }

  paginationHandler(event) {
    const newActiveBtn = event.target.closest("button");
    if (!newActiveBtn) return;
    const { doctorResultsPage } = newActiveBtn.dataset;
    const newActivePage = this.resultsList.querySelector(
      `.doctor-results-page[data-doctor-results-page="${doctorResultsPage}"]`
    );

    const prevActiveBtn = this.paginationContainer.querySelector(
      `button[data-doctor-results-active-page="true"]`
    );
    const prevActivePage = this.resultsList.querySelector(
      `[data-doctor-results-active-page="true"]`
    );

    prevActiveBtn.dataset.doctorResultsActivePage = false;
    newActiveBtn.dataset.doctorResultsActivePage = true;
    prevActivePage.dataset.doctorResultsActivePage = false;
    newActivePage.dataset.doctorResultsActivePage = true;

    this.scrollSectionIntoView();
  }

  buildPaginationButtons(pages) {
    let paginationButtons = [];
    let page = 1;
    while (page <= pages) {
      let buttonMarkup = `
      <button 
        data-doctor-results-active-page="${page === 1 ? true : false}" 
        data-doctor-results-page="${page}"
        aria-label="Button for page ${page}">
          ${page}
      </button>`;
      paginationButtons.push(buttonMarkup);
      page++;
    }

    this.paginationContainer.innerHTML = ``;
    this.paginationContainer.innerHTML = `
      ${paginationButtons.map((el) => el).join("")}
    `;
  }

  buildPaginationPages(data, pages) {
    let paginatedArray = [];
    for (let index = 0; index < data.length; index += pages) {
      paginatedArray.push(data.slice(index, index + pages));
    }
    return paginatedArray;
  }

  parseEndorsementString(stringToParse) {
    const parsedHTML = this.domParser.parseFromString(
      stringToParse,
      "text/html"
    );
    const outerHtml = parsedHTML.querySelector("body").outerHTML;
    return `<div class="doctor-card--endorsement"><p>${outerHtml}</p></div>`;
  }

  removeLoadingState() {
    this.loadingSpinner.dataset.showLoading = false;
  }

  toggleEmptyResultsMessage(flag) {
    this.emptyState.dataset.showEmpty = flag;
  }

  togglePagination(flag) {
    this.paginationContainer.dataset.showPagination = !flag;
  }

  formatLocationObject(locationString) {
    return locationString.split(",").map((item) => item.trim());
  }

  stringIncludesCaseInsensitive(stringToLookFor, stringToSearchIn) {
    return new RegExp(stringToLookFor, "i").test(stringToSearchIn);
  }

  scrollSectionIntoView() {
    document.querySelector("#doctor-search--container").scrollIntoView({
      behavior: "smooth",
    });
  }

  disconnectedCallback() {
    document.removeEventListener("doctors-data-parsed");
    document.removeEventListener("doctor-search-filter");
    this.paginationContainer.addEventListener("click");
  }
}

customElements.define("doctor-search-specialty-filters", SpecialtyFilters);
customElements.define("doctor-search-location-filter", LocationFilter);
customElements.define("doctor-search-filters", DoctorSearchFilters);
customElements.define("doctor-search-results", SearchResults);

const doctorSearch = new DoctorSearch();
